
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Calendar, ArrowLeft } from 'lucide-react';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50 px-4">
      <div className="max-w-md text-center space-y-6 animate-fade-in">
        <div className="flex justify-center">
          <div className="rounded-full bg-primary/10 p-6 mb-3">
            <Calendar className="h-16 w-16 text-primary" />
          </div>
        </div>
        
        <h1 className="text-5xl font-bold">404</h1>
        <h2 className="text-2xl font-medium">Pagina niet gevonden</h2>
        
        <p className="text-muted-foreground">
          De pagina die u zoekt bestaat niet of is mogelijk verplaatst.
        </p>
        
        <Button 
          onClick={() => navigate('/dashboard')} 
          className="mt-4 flex items-center"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Terug naar dashboard
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
